import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import BlockComponent from "../../components/Loading/BlockComponent";
import Button from "../../components/Buttons/Button";
import CustomInput from "../../components/CustomInput/CustomInput.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import extendedFormsStyle from "../../components/Form/FormsStyle.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";

import pageStyle from "../../components/Page/PageStyle";
import {getTiposCuentas} from "../../core/tiposCuentas/tiposCuentas-actions";
import {getCuentas} from "../../core/cuentas/cuentas-actions";

import * as AuthService from "../../core/auth/auth-actions";

const styles = (theme) => ({
	...pageStyle(theme),
	...extendedFormsStyle,
	selectEmpty :{
		minWidth:'150px'
	},
});

const FiltroEstadoDeudaComponent = (props) => {
	const [item, setItem] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const tiposCuentas = (state) => {
    return state.tiposCuentas;
  };
  const cuentas = (state) => {
    return state.cuentas;
  };
  const user = (state) => {
    state.auth.user;
  };
  const {classes, tiposCuentas: {data: dataTiposCuentas, loadingTiposCuentas},
    cuentas :{data:dataCuentas}} = props;
  const loading = loadingTiposCuentas;
  const dispatch = useDispatch();


	useEffect(() => {
		const usuario = user?.id ??  null;
		return Promise.all([
			dispatch(getTiposCuentas({})),
			dispatch(getCuentas({usuario})),
		])
	}, []);

	const bindValue = key => {
		//Cuando isLoggedIn se mapean datos de la cuenta.
		if (key === 'cuenta'){
			return {
				onChange: e => {
					const cuenta = cuentas.data.filter((item) => item.idCuenta === e.target.value).shift();
					const newItem = {...item};
					newItem['cuentaNro'] = null;
					newItem['tipoCuentaId'] = null;
					if (cuenta !== undefined){
						newItem['cuentaNro'] = cuenta.cuentaNro;
						newItem['tipoCuentaId'] = cuenta.tipoCuentaId;
					}
          setItem(newItem);
				}
			};
		}

		return {
			onChange: e => {
				const newItem = {...item};
				newItem[key] = e.target.value;
				setItem(newItem);
			},
			value: item[key] || ''
		};
	};

	const handleOnSearch = (event) => {
		event.stopPropagation();
		event.preventDefault();
		if (validarDatos(item))
			return props.onSearch(item.tipoCuentaId, item.cuentaNro);
	}

	const validarDatos = (item) => {
		if (AuthService.isLoggedIn() && (!item.cuentaNro || !item.tipoCuentaId)){
			setErrorMessage('Debe seleccionar una Cuenta');
			return false;
		}
		if (!AuthService.isLoggedIn()){
			if (!item.tipoCuentaId) {
        setErrorMessage('Ingrese Tipo de Cuenta');
				return false;
			}
			if (!item.cuentaNro){
				setErrorMessage('Ingrese Número de Cuenta');
				return false;
			}
		}
    setErrorMessage("");
		return true;
	}
  return (
    <BlockComponent blocking={loading}>
      <GridContainer>
        <GridItem xs={12} sm={6} >
          <FormControl required className={classes.selectFormControl}>
            { AuthService.isLoggedIn()
              ?
                <div>
                  <InputLabel htmlFor="cuenta">Seleccione una Cuenta</InputLabel>
                  <Select
                    {...bindValue('cuenta')}
                    name="cuentaNro"
                    inputProps={{
                      id: 'cuenta',
                    }}
                    className={classes.selectEmpty}
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    native
                  >
                  <option value="" ></option>
                  {dataCuentas.map(({idCuenta, descripcion}, key) => {
                    return (<option
                              key={key}
                              type='number'
                              value={idCuenta}
                            >{descripcion}</option>);
                  })}
                  </Select>
                </div>
              :
                <div>
                  <InputLabel htmlFor="tipoCuentaId">Tipo de Cuenta</InputLabel>
                  <Select

                    {...bindValue('tipoCuentaId')}
                    name="tipoCuentaId"
                    inputProps={{
                      id: 'tipoCuentaId',
                    }}
                    className={classes.selectEmpty}
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    native
                  >
                    <option value="" disabled></option>
                    {dataTiposCuentas.map(({id, descripcion}, key) => {
                      return (<option key={key} value={id}>{descripcion}</option>);
                    })}
                  </Select>
                </div>
            }

          </FormControl>
        </GridItem>
        { ! AuthService.isLoggedIn()
          ?
            <GridItem xs={12} sm={3} >
              <CustomInput
                labelText="Número"
                id="nummero"
                formControlProps={{
                  fullWidth: false,

                }}
                inputProps={{
                  required: true,
                  ...bindValue('cuentaNro'),
                  type: 'Number'
                }}
                labelProps={{
                  style: {top: "0px"}
                }}
              />
            </GridItem>
          :
            <div></div>
        }
        <GridItem xs={12} sm={3} >
          <Button
            fullWidth={true}
            size="large"
            color="primary"
            onClick={handleOnSearch}>Consultar</Button>
        </GridItem>
      </GridContainer>
      <div style={{color: "red"}}>{errorMessage}</div>
    </BlockComponent>
  );
}
export default withStyles(styles)(FiltroEstadoDeudaComponent);
